import { render, staticRenderFns } from "./questionKnowledge.vue?vue&type=template&id=795fffe5&scoped=true&"
import script from "./questionKnowledge.vue?vue&type=script&lang=js&"
export * from "./questionKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795fffe5",
  null
  
)

export default component.exports